import React from 'react';
import { toAbsoluteUrl } from '../../../assets/helpers/AssetHelpers';
import { Link } from 'react-router-dom';
import { ListSection } from './ListSection';
import {
	InvestmentService,
	investTradeItems,
	noticeBoardItems,
	platformItems,
	researchItems,
	servicesLinks,
} from './navbarConstants';
import { NavCtaLinks } from './NavCtaLinks';

/**
 * The mega-menu content of the mobile/tablet offcanvas nav. Pulled out of Navbar.tsx and
 * memoized because it only ever renders these static constants (no props) — it never needs
 * to re-render for header-search keystrokes, window resizes, or the hamburger animation
 * that live in the parent Navbar.
 */
const NavbarOffcanvasMenuComponent: React.FC = () => (
	<div className="offcanvas offcanvas-top r-vh" tabIndex={-1} id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
		<div className="offcanvas-header px-4">
			<div className="offcanvas-title" id="offcanvasExampleLabel">
				<img src={toAbsoluteUrl('navbar-section/jainam.webp')} alt="jainam" width={150} />
			</div>
			<button
				type="button"
				className="btn-close btn_close"
				data-bs-dismiss="offcanvas"
				aria-label="Close"></button>
		</div>
		<div className="offcanvas-body px-4">
			<div className="accordion" id="accordionExample">
				<div className="accordion-item border-0">
					<h2 className="accordion-header" id="headingProduct">
						<button
							className="accordion-button px-0 accordion_button_focus accordion-button-collapsed accordion-offcanva-button fs-14 in_med bg-transparent collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseProduct"
							aria-expanded="true"
							aria-controls="collapseProduct">
							Product
						</button>
					</h2>
					<div
						id="collapseProduct"
						className="accordion-collapse accordion_collapse collapse"
						aria-labelledby="headingProduct"
						data-bs-parent="#accordionExample">
						<div className="accordion-body py-1 px-0">
							<div className="row gx-0">
								<div className="col-lg-2 mt-4 mt-lg-0">
									<ListSection title="Platform" items={platformItems} />
									<ListSection title="Services" items={servicesLinks} />
								</div>
								<div className="col-lg-2">
									<ListSection title="Invest & Trade" items={investTradeItems} />
								</div>
								<div className="col-lg-2">
									<ListSection title="Investment Service" items={InvestmentService} />
								</div>
								<div className="col-lg-6">
									<div className="d-flex justify-content-lg-end">
										<img
											className="img-fluid"
											src={toAbsoluteUrl('herosection-images/ProductNavbarCard.svg')}
											alt=""
										/>
									</div>
									<a href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}indian-options-conclave-7-0/`} className="d-flex justify-content-lg-end mt-3">
										<img
											className=""
											src={toAbsoluteUrl(
												"herosection-images/ioc.svg",
											)}
											alt=""
										/>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="accordion-item border-0">
					<h2 className="accordion-header" id="headingResources">
						<button
							className="accordion-button px-0 accordion_button_focus accordion-button-collapsed accordion-offcanva-button fs-14 in_med bg-transparent collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseResources"
							aria-expanded="false"
							aria-controls="collapseResources">
							Resources
						</button>
					</h2>
					<div
						id="collapseResources"
						className="accordion-collapse accordion_collapse collapse"
						aria-labelledby="headingResources"
						data-bs-parent="#accordionExample">
						<div className="accordion-body py-1 px-0">
							<div className="row gx-0 pt-3 pt-lg-0">
								<div className="col-md-6 col-lg-3 nav-pad-y">
									<ListSection title="Research" items={researchItems} />
								</div>
								<div className="col-md-6 col-lg-3 nav-pad-y">
									<ListSection title="Notice Board" items={noticeBoardItems} />
								</div>
								<div className="col-md-6 col-lg-5">
									<div className="active-bg px-3 nav-pad-y h-100">
										<div className="fs-18 in_semi mb-4 lh-22 color28">
											News
											<div className="fs-12 in_reg my-2">
												Get to know the rationale behind great ideas for you to make sound long term investment decisions.
											</div>
										</div>
										<div className="fs-18 in_semi mb-4 lh-22 color28">
											Blogs
											<div className="fs-12 in_reg my-2">
												Explore our blogs and guides to gain insights and learn how to get started with trading and investments.
											</div>
										</div>
										<div className="fs-18 in_semi mb-4 lh-22 color28">
											FAQs
											<div className="fs-12 in_reg my-2">
												Find answers to your questions with our comprehensive set of FAQs. If you need further assistance, our Support team is here to help!
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-6 col-lg-1 nav-pad-y">
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="accordian-pad">
					<a
						href="https://jainam.in/pricing/"
						className="nav-link nav-link-font in_reg fs-14 px-xl-3 color28">
						Pricing
					</a>
				</div>

				<div className="accordion-item border-0">
					<h2 className="accordion-header" id="headingSupport">
						<button
							className="accordion-button px-0 accordion_button_focus accordion-button-collapsed accordion-offcanva-button fs-14 in_med bg-transparent collapsed"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#collapseSupport"
							aria-expanded="false"
							aria-controls="collapseSupport">
							Support
						</button>
					</h2>
					<div
						id="collapseSupport"
						className="accordion-collapse accordion_collapse collapse"
						aria-labelledby="headingSupport"
						data-bs-parent="#accordionExample">
						<div className="accordion-body p-0">
							<ul className="list-unstyled ">
								<li className="mt-1 mb-3">
									<a
										href="https://jainam.in/contact-us/"
										className="color28 in_med lh-19 li-link">
										Contact Us
									</a>
								</li>
								<li className="my-3">
									<a href="https://support.jainam.in/" className="color28 in_med lh-19 li-link">
										FAQs
									</a>
								</li>
								<li className="my-3">
									<a
										href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}forms/`}
										className="color28 in_med lh-19 li-link">
										Downloads
									</a>
								</li>
								<li className="my-3">
									<Link
										to={`${process.env.REACT_APP_URL}videos/`}
										className="color28 in_med lh-19 li-link">
										Knowledge Base
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<form className="p-3 px-0 d-block" role="search">
					<NavCtaLinks variant="offcanvas" />
				</form>
			</div>
		</div>
	</div>
);

export const NavbarOffcanvasMenu = React.memo(NavbarOffcanvasMenuComponent);
